/**
 * @module interface
 */
 export interface V2TimImage {
    uuid?: string;
    type?: number;
    size?: number;
    width?: number;
    height?: number;
    url?: string;
    localUrl?: string;
}
